/**
 * A small box for writing on a sign. While its input has focus the game
 * ignores the keyboard (Input's isTyping), so typing WASD doesn't walk you off.
 */
export class SignEditor {
  private readonly root = document.getElementById("sign-editor")!;
  private readonly input = this.root.querySelector<HTMLInputElement>(".sign-text")!;
  private done: ((text: string) => void) | null = null;

  constructor() {
    this.root.querySelector(".sign-save")!.addEventListener("click", () => this.save());
    this.root.querySelector(".sign-cancel")!.addEventListener("click", () => this.close());
    this.input.addEventListener("keydown", (e) => {
      // Kept to ourselves, so Escape doesn't also close a map or panel behind.
      e.stopPropagation();
      if (e.key === "Enter") {
        e.preventDefault();
        this.save();
      } else if (e.key === "Escape") {
        e.preventDefault();
        this.close();
      }
    });
  }

  /** Show the editor with `initial` in it; `onDone` gets the text on Save (not on Cancel). */
  open(initial: string, onDone: (text: string) => void): void {
    this.done = onDone;
    this.input.value = initial;
    this.root.classList.remove("hidden");
    this.input.focus();
    this.input.select();
  }

  get isOpen(): boolean {
    return !this.root.classList.contains("hidden");
  }

  close(): void {
    this.done = null;
    this.input.blur();
    this.root.classList.add("hidden");
  }

  private save(): void {
    const done = this.done;
    const text = this.input.value.trim();
    this.close();
    done?.(text);
  }
}
